import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

const rubles = (value: number) =>
    new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2, style: 'currency', currency: 'RUB' }).format(value);

export default function AutoTopUpChoice({
    checked,
    onChange,
    oneTimeUnit,
    monthlyUnit,
    packageSize,
    disabled = false,
}: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    oneTimeUnit: number;
    monthlyUnit: number;
    packageSize: number;
    disabled?: boolean;
}) {
    const saving = Math.max(0, (oneTimeUnit - monthlyUnit) * packageSize);

    return (
        <Box sx={{ border: '1px solid', borderColor: checked ? 'var(--lm-accent-ink)' : 'var(--lm-border)', borderRadius: '8px', bgcolor: checked ? 'var(--lm-accent-soft)' : 'var(--lm-surface)', px: 1.5, py: 0.5 }}>
            <FormControlLabel
                sx={{ m: 0, width: '100%', alignItems: 'center', '& .MuiFormControlLabel-label': { width: '100%' } }}
                control={<Checkbox checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} />}
                label={
                    <Box sx={{ py: 0.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: 1 }}>
                            <Typography sx={{ fontSize: 15, fontWeight: 700, color: 'var(--lm-text)' }}>Включить автопополнение</Typography>
                            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'var(--lm-success-ink)' }}>−10%</Typography>
                        </Box>
                        <Typography sx={{ fontSize: 13, color: 'var(--lm-muted)' }}>
                            {oneTimeUnit > 0 && monthlyUnit > 0
                                ? `${rubles(monthlyUnit)}/лид · экономия ${rubles(saving)}/мес. Цена закрепится после оплаты.`
                                : 'Выберите объём лидов'}
                        </Typography>
                    </Box>
                }
            />
        </Box>
    );
}
